module.exports = __webpack_public_path__ + "static/band01.ada47901.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/band01.png
// module id = 501
// module chunks = 114276838955818